/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * sort
 */
export enum Sort {
  BESTSELLING = 'bestselling',
  NEW = 'new',
  TRENDING = 'trending',
}
